module.exports = __webpack_public_path__ + "img/news3-12.b70ab238.jpeg";